import React from 'react';

const PremiumScarcity = () => {
  // Função para criar o link do WhatsApp
  const createWhatsAppLink = (message) => {
    const phoneNumber = "5537998630380";
    const encodedMessage = encodeURIComponent(message);
    return `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
  };

  return (
    <section className="py-16 bg-gradient-to-r from-red-900 to-black text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold mb-8">
            Um trabalho de excelência requer critérios de excelência
          </h2>
          
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="bg-black bg-opacity-50 p-6 rounded-lg border border-red-600">
              <div className="text-3xl font-bold text-red-400 mb-3">Limitado</div>
              <h3 className="text-lg font-bold mb-3">Atendimentos Simultâneos</h3>
              <p className="text-gray-300 text-sm">
                Para garantir a qualidade e profundidade necessárias, atendo apenas um número limitado de pessoas simultaneamente.
              </p>
            </div>
            
            <div className="bg-black bg-opacity-50 p-6 rounded-lg border border-red-600">
              <div className="text-3xl font-bold text-red-400 mb-3">Seletivo</div>
              <h3 className="text-lg font-bold mb-3">Processo de Avaliação</h3>
              <p className="text-gray-300 text-sm">
                Realizamos uma avaliação inicial para garantir que há fit entre sua demanda e minha abordagem terapêutica.
              </p>
            </div>
            
            <div className="bg-black bg-opacity-50 p-6 rounded-lg border border-red-600">
              <div className="text-3xl font-bold text-red-400 mb-3">Premium</div>
              <h3 className="text-lg font-bold mb-3">Investimento Diferenciado</h3>
              <p className="text-gray-300 text-sm">
                Um trabalho de transformação profunda requer investimento compatível com a profundidade e resultados esperados.
              </p>
            </div>
          </div>
          
          <div className="bg-white text-black p-8 rounded-lg mb-8">
            <h3 className="text-xl font-bold mb-4">
              Agenda atual: 70% de ocupação
            </h3>
            <p className="text-gray-700 mb-6">
              Devido à natureza intensiva do trabalho, mantenho uma agenda controlada para garantir 
              a qualidade e atenção que cada processo merece.
            </p>
            
            <div className="flex justify-center mb-6">
              <div className="w-full max-w-md bg-gray-200 rounded-full h-4">
                <div className="bg-red-600 h-4 rounded-full" style={{width: '70%'}}></div>
              </div>
            </div>
            
            <p className="text-sm text-gray-600">
              <strong>Próximas vagas disponíveis:</strong> Consulte disponibilidade atual
            </p>
          </div>
          
          <div className="text-center">
            <p className="text-lg mb-6 text-gray-300">
              Se você está verdadeiramente comprometido com sua transformação emocional 
              e busca um trabalho sério e profundo...
            </p>
            
            <a 
              href={createWhatsAppLink("Olá, gostaria de verificar a disponibilidade de vagas e saber mais sobre o processo seletivo para atendimento.")} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn btn-accent text-lg px-10 py-4 inline-block"
            >
              VERIFICAR DISPONIBILIDADE
            </a>
            
            <p className="text-sm text-gray-400 mt-4">
              Resposta em até 24 horas úteis
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PremiumScarcity;

